import React, { useMemo } from 'react'

const MIN_TILE_VALUE = 0.0001

const buildTreemapLayout = (entries, horizontal = true, x = 0, y = 0, width = 100, height = 100) => {
  if (!entries.length) return []

  if (entries.length === 1) {
    return [{ ...entries[0], x, y, width, height }]
  }

  const total = entries.reduce((sum, entry) => sum + entry.value, 0)
  const target = total / 2
  const left = []
  let leftTotal = 0

  entries.forEach((entry) => {
    if (leftTotal < target || left.length === 0) {
      left.push(entry)
      leftTotal += entry.value
    }
  })

  const right = entries.slice(left.length)
  const safeTotal = total || 1
  const ratio = leftTotal / safeTotal

  if (horizontal) {
    const leftWidth = width * ratio
    return [
      ...buildTreemapLayout(left, false, x, y, leftWidth, height),
      ...buildTreemapLayout(right, false, x + leftWidth, y, width - leftWidth, height),
    ]
  }

  const topHeight = height * ratio
  return [
    ...buildTreemapLayout(left, true, x, y, width, topHeight),
    ...buildTreemapLayout(right, true, x, y + topHeight, width, height - topHeight),
  ]
}

export default function WinnerTree({ data }) {
  const tiles = useMemo(() => {
    const entries = data
      .filter(entry => entry.winner > 0)
      .map(entry => ({
        country: entry.country,
        name: entry.name || entry.country,
        flag: entry.flag || '/flags/Mystery.png',
        value: Math.max(entry.winner, MIN_TILE_VALUE),
      }))
      .sort((a, b) => b.value - a.value)

    return buildTreemapLayout(entries)
  }, [data])

  if (!tiles.length) {
    return null
  }

  return (
    <section className="winner-tree">
      <div className="winner-tree-canvas">
        {tiles.map(tile => (
          <article
            key={tile.country}
            className="winner-tree-tile"
            style={{
              left: `${tile.x}%`,
              top: `${tile.y}%`,
              width: `${tile.width}%`,
              height: `${tile.height}%`,
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.32)), url("${tile.flag}")`,
            }}
            title={tile.name}
          />
        ))}
      </div>
    </section>
  )
}
